"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('textarea');
const ATextarea = (props) => {
    const { className = '', name, value, placeholder, disabled, maxlength, focus, autoHeight, showCount, rows = 3, controlled = false, onChange, onFocus, onBlur, onConfirm, } = props;
    const handleChangeInput = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return (React.createElement(one_1.View, { className: prefixCls },
        React.createElement(one_1.Textarea, { className: classnames_1.default({
                [`${prefixCls}-default`]: true,
                [className]: true,
            }), 
            // @ts-ignore
            placeholderClass: `${prefixCls}-placeholder`, name: name, value: value, placeholder: placeholder, disabled: disabled, maxlength: maxlength, focus: focus, autoHeight: autoHeight, showCount: showCount, controlled: controlled, onInput: handleChangeInput, onFocus: onFocus, onBlur: onBlur, onConfirm: onConfirm, rows: rows })));
};
exports.default = ATextarea;
